import { TAGLink } from '@aspendental/shared-components-web';
import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
interface TermsAndConditionsProps {
  baseUrl: string;
}
const TermsAndConditions = ({
  baseUrl
}: TermsAndConditionsProps) => {
  const {
    t
  } = useTranslation('index');
  return <Typography variant="bodySmallBook" color="text.secondary" textAlign="center" mb={2.5} px={2.5} data-sentry-element="Typography" data-sentry-component="TermsAndConditions" data-sentry-source-file="TermsAndConditions.tsx">
			{t('consentFromClick')}{' '}
			<TAGLink href={`${baseUrl}/legal/terms/`} linkSx={{
      textDecoration: 'underline',
      textDecorationColor: '#036896'
    }} openInNewTab data-sentry-element="TAGLink" data-sentry-source-file="TermsAndConditions.tsx">
				<Typography variant="bodySmallBook" color="text.interactive" data-sentry-element="Typography" data-sentry-source-file="TermsAndConditions.tsx">
					{t('termsAndConditions')}
				</Typography>
			</TAGLink>{' '}
			{t('and')}{' '}
			<TAGLink href={`${baseUrl}/legal/privacy-policy/`} linkSx={{
      textDecoration: 'underline',
      textDecorationColor: '#036896'
    }} openInNewTab data-sentry-element="TAGLink" data-sentry-source-file="TermsAndConditions.tsx">
				<Typography variant="bodySmallBook" color="text.interactive" data-sentry-element="Typography" data-sentry-source-file="TermsAndConditions.tsx">
					{t('privacyPolicy')}
				</Typography>
			</TAGLink>
			.
		</Typography>;
};
export default TermsAndConditions;